<template>
    <article class="instagram-card">
        <NuxtLink :to="post?.articleUrl" :title="post?.articleCaption" :external="true" target="_blank">
            <div class="instagram-card-media">
                <UiImage :src="post?.webp" :classes="'responsive'" />
            </div>
        </NuxtLink>
    </article>
</template>

<script setup lang="ts">
defineProps({
    post: {
        type: Object,
        default: () => ({})
    }
});
</script>
